import styled, { css } from "styled-components";

type Status = "checking" | "success" | "pending" | "error";

export const PS_Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-height: 70vh;
	padding: 24px;
`;

export const PS_Card = styled.div`
	width: 100%;
	max-width: 520px;
	padding: 32px;
	border-radius: 24px;
	background: #fff;
	box-shadow: 0 18px 60px rgb(0 0 0 / 10%);
	text-align: center;
`;

export const PS_Status = styled.div<{ $status: Status }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 6px 12px;
	border-radius: 999px;
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;

	${({ $status }) => {
		if ($status === "success") {
			return css`
				background: #e8f8ee;
				color: #1f9d4c;
			`;
		}

		if ($status === "error") {
			return css`
				background: #fdecec;
				color: #c0392b;
			`;
		}

		if ($status === "pending") {
			return css`
				background: #fff6df;
				color: #b7791f;
			`;
		}

		return css`
			background: #edf2f7;
			color: #4a5568;
		`;
	}}
`;

export const PS_Title = styled.h1`
	margin: 20px 0 0;
	font-size: 32px;
	line-height: 1.2;
	font-weight: 700;
	color: #111;
`;

export const PS_Description = styled.p`
	margin: 12px 0 0;
	font-size: 16px;
	line-height: 1.5;
	color: #666;
`;

export const PS_Actions = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
	margin-top: 28px;

	@media (max-width: 560px) {
		flex-direction: column;
	}
`;

export const PS_Button = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 44px;
	padding: 0 18px;
	border: 1px solid #d8d8d8;
	border-radius: 12px;
	background: #fff;
	color: #222;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: 0.2s;

	&:hover {
		transform: translateY(-1px);
	}
`;
